import { apiRequest } from '../../../api/client';
import type { ProductGuidanceAnalyticsAccepted, ProductGuidanceAnalyticsEvent } from '../types/product-guidance';

export function recordProductGuidanceEvent(event: ProductGuidanceAnalyticsEvent) {
  return apiRequest<ProductGuidanceAnalyticsAccepted>('/v1/product-guidance/events', {
    method: 'POST',
    body: JSON.stringify(event),
  });
}

/** Analytics must never block or visually degrade the user's Route42 task. */
export function recordProductGuidanceEventBestEffort(event: ProductGuidanceAnalyticsEvent) {
  void recordProductGuidanceEvent(event).catch(() => undefined);
}
